import { z } from 'zod';
import { claimStatusSchema } from '@zealy/schemas';
import { query, router } from '../../utils';
export const getClaimStatus = query({
    method: 'GET',
    path: '/:id/status',
    pathParams: z.object({ id: z.string() }),
    responses: {
        200: claimStatusSchema,
        202: claimStatusSchema,
        400: claimStatusSchema,
    },
});
export const claimsContract = router({
    getStatus: getClaimStatus,
}, {
    pathPrefix: '/communities/:subdomain/claims',
});
